import { createContext, useContext, useEffect, useMemo, useState } from "react";
import pt from "./i18n/pt";


// patch 30: English is a separate download, fetched only when needed (Portuguese is the default)
let EN = null;
const loadEn = () => import(/* webpackChunkName: "i18n-en" */ "./i18n/en").then((m) => { EN = m.default; return EN; });

function initialLang() {
  try {
    const saved = localStorage.getItem("tierpt_lang");
    if (saved === "en" || saved === "pt") return saved;
  } catch {
    /* storage blocked */
  }
  const nav = typeof navigator !== "undefined" ? navigator.language || "" : "";
  return nav.toLowerCase().startsWith("pt") ? "pt" : "en";
}
// start downloading English while the app is still booting, so English visitors never see Portuguese first
if (typeof window !== "undefined" && initialLang() === "en") loadEn().catch(() => {});

const I18nContext = createContext({ lang: "pt", t: pt, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(initialLang);

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("tierpt_lang", l);
  };

  useEffect(() => {
    document.documentElement.lang = lang === "en" ? "en" : "pt-PT";   // patch 42
  }, [lang]);

  const [, setEnReady] = useState(!!EN);
  const [waited, setWaited] = useState(() => lang !== "en");   // only the very first English paint waits for the file
  useEffect(() => {
    if (lang !== "en" || EN) return undefined;
    loadEn().then(() => setEnReady(true)).catch(() => setWaited(true));
    const id = setTimeout(() => setWaited(true), 2500);   // slow network: show Portuguese rather than nothing
    return () => clearTimeout(id);
  }, [lang]);
  const t = lang === "en" ? EN || pt : pt;
  const value = useMemo(() => ({ lang, t, setLang }), [lang, t]);   // eslint-disable-line react-hooks/exhaustive-deps
  if (lang === "en" && !EN && !waited) return null;   // a few ms on first English visit (file comes in parallel)
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
